import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { setTablaLoteria, setListaZonas } from '../../../../actions'
import { alerta } from '../../../../services/utilities';
import { getLoterias } from '../../../../services/Loterias';
import { getZonas } from '../../../../services/Zona';
import Header from "../../../header/Header";
import Aside from "../../../aside/Aside";
import HeaderModulo from "../../../header/HeaderModulo";
import Lista from "./Lista";
import Nueva from "./Nueva";
import Editar from './Editar';

function Zonas(props){

    useEffect(() => {

        getLoterias().then(response => {
            if(response.status === 200){
                props.setTablaLoteria(response.data)
            }else{
                alerta('No se cargo la tabla de loterias o no hay loterias actualemente creadas',response.response.data.status_message??response.message,'warning');
            }
        });

        getZonas().then(response => {
            if(response.status === 200){
                props.setListaZonas(response.data.data)
            }else{
                alerta('No se cargo la lista de zonas o no hay zonas actualemente creadas',response.response.data.status_message??response.message,'warning');
            }
        });
    
    }, []);

    return(
        <React.Fragment>
            <Header></Header>
            <Aside></Aside>
            <main id="main" className="main">
                <HeaderModulo nombre_modulo={props.modulo}></HeaderModulo>
                <section className="section">
                    <div className="row">
                        <Nueva></Nueva>
                        <Lista></Lista>
                    </div>
                    <Editar></Editar>
                </section>
            </main>
        </React.Fragment>
    );
}

const mapDispatchToProps  = {
    setTablaLoteria,
    setListaZonas
};

export default connect(null, mapDispatchToProps)(Zonas)